import AddQuestion from './AddQuestion';
import ContactUs from './ContactUs';

export { AddQuestion, ContactUs };
